// Self-service API key management for the current user.
// Follows the factory pattern established in other API files.

import type { ApiClient } from './client'

export interface MyApiKeyStatus {
  has_api_key: boolean
  key_status?: 'unactivated' | 'active' | 'revoked'
  key_prefix?: string
  activated_at?: string
  revoked_at?: string
  last_used_at?: string
}

export function myApiKeyApi(api: ApiClient) {
  return {
    getStatus: () => api.get<MyApiKeyStatus>('/me/api-key'),
    activate: (data: { key_hash: string; key_prefix: string }) =>
      api.post<{ status: string }>('/me/api-key/activate', data),
    revoke: () => api.post<{ status: string }>('/me/api-key/revoke'),
  }
}
